import styled from 'styled-components';

export const Content = styled.div`
`;

export const ButtonExternalLink = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F5EDFF;
  padding: 0.4rem 0.5rem;
  margin: 0;
  border-radius: 0.4rem;
  font-size: 0.75rem;
  border: none;
`;

export const TitleAbout = styled.h2`
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: 700;
  font-size: 1.125rem;
  color: ${({ theme }) => theme.colors.primaryBlue.main};
  gap: 1rem;
`;

export const BulletTitle = styled.h5`
  align-items: center;
  color: #272727;
  display: flex;
  font-size: 1rem;
  margin: 0.75rem 0 0.625rem;
  position: relative;
`;